import React from 'react'
import { inject, observer } from 'mobx-react'

const StatusMessage = ({ uiStore }) => (
  uiStore.statusMessage
    ? (
      <p className={`status-message status-message--${uiStore.statusMessageType}`}>
        {uiStore.statusMessage}
      </p>
      )
    : null
)

export default inject('uiStore')(observer(StatusMessage))
